import React, { useEffect, useState } from "react";
import LikeGradientIcon from "../../assets/icons/like-gradient.svg";
import "./index.less";

interface LikeAnimationProps {
  trigger: boolean;
  onAnimationEnd?: () => void;
}

const LikeAnimation: React.FC<LikeAnimationProps> = ({ trigger, onAnimationEnd }) => {
  const [show, setShow] = useState(false);

  useEffect(() => {
    if (trigger) {
      setShow(true);
      const timer = setTimeout(() => {
        setShow(false);
        onAnimationEnd?.();
      }, 1000);

      return () => clearTimeout(timer);
    }
  }, [trigger, onAnimationEnd]);

  if (!show) return null;

  return (
    <div className="like-animation-overlay">
      <img src={LikeGradientIcon} alt="like" className="like-animation-heart" />
    </div>
  );
};

export default LikeAnimation;
